<div class="page-header">
	<div>
		<h1 class="page-title">Search Subscriber</h1>
		<div class="page-subtitle">By Sim</div>
	</div>
</div>

<div class="row mt-3">
	<div class="col">
		<app-table
			[downloadHeading]="'Subscriber Sim Search'"
			[downloadName]="'subscriber_sim_search'"
			[data]="results"
			[headerClass]="'table-info'"
			[columns]="columnRef"
			[filters]="filters"
			[loading]="loading"
			(onRowClick)="open($event)"
			(onUpdateRequired)="doFetchResults($event)"
			[showSearchHelp]="false"
			(onShowSearchHelpClicked)="showSearchHelp(searchHelp)"
			[filterModal]="filterModal"
			>
			<ng-template #givenNames let-row="row">
				<td>
					{{row.document.firstName??''}} {{row.document.secondName??''}} {{row.document.otherNames??''}}
				</td>
			</ng-template>
			<ng-template #toDate let-row="row">
				<td>
					{{row.msisdn.endDate??'-'}}
				</td>
			</ng-template>
			<ng-template #simStatus let-row="row">
				<td>
					<span *ngIf="row.msisdn.simStatus == 'Active'" class="text-success">Active</span>
					<span *ngIf="row.msisdn.simStatus == 'Swapped'" class="text-warning">Swapped</span>
					<span *ngIf="row.msisdn.simStatus == 'Transferred'" class="text-warning">Transferred</span>
					<span *ngIf="row.msisdn.simStatus == 'Terminated'" class="text-warning">Terminated</span>
				</td>
			</ng-template>
			<ng-template #documentStatus let-row="row">
				<td>
					<fa-icon [icon]="faCheck" *ngIf="row.msisdn.documentStatus == 'Perfect'" class="text-success"></fa-icon>
					<fa-icon [icon]="faCheck" *ngIf="row.msisdn.documentStatus == 'Match'" class="text-success"></fa-icon>
					<fa-icon [icon]="faCheck" *ngIf="row.msisdn.documentStatus == 'Acceptable'" class="text-success"></fa-icon>
					<fa-icon [icon]="faXmark" *ngIf="row.msisdn.documentStatus == 'Failed'" class="text-danger"></fa-icon>
					<fa-icon [icon]="faNotdef" *ngIf="row.msisdn.documentStatus == 'NotFound'" class="text-warning"></fa-icon>
					<fa-icon [icon]="faHourglass" *ngIf="row.msisdn.documentStatus == 'Skipped'" class="text-secondary"></fa-icon>
					<fa-icon [icon]="faHourglass" *ngIf="row.msisdn.documentStatus == 'Pending'" class="text-secondary"></fa-icon>
				</td>
			</ng-template>
		</app-table>
	</div>
</div>

<ng-template #searchHelp let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Search Help</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body">
		<p>You can search for a subscriber using the following identifiers:</p>
		<ul>
			<li><strong>MSISDN:</strong> Enter the phone number in international or local format.</li>
			<li><strong>ICCID:</strong> Enter the SIM cards ICCID, with or without the check digit.</li>
			<li><strong>SIM Serial:</strong> Enter the SIM cards serial number.</li>
		</ul>
		<p>This allows flexible and efficient lookup of subscriber or SIM information using industry-standard identifiers.</p>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modal.close('Close click')">Close</button>
	</div>
</ng-template>

<ng-template #filterModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Subscriber Search</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body" [formGroup]="filterForm">


		<p>You can search for a subscriber using the following identifiers:</p>

		<div class="form-floating">
			<input type="text" id="msisdn" class="form-control" placeholder="Enter MSISDN" name="msisdn" formControlName="msisdn" [(ngModel)]="getFilter('msisdn').value">
			<label for="msisdn">MSISDN</label>
			<div *ngIf="filterForm.get('msisdn')?.invalid && filterForm.get('msisdn')?.touched" class="text-danger small">
				<span *ngIf="filterForm.get('msisdn')!.errors">Expected a value of 7 to 15 digits long and only 0-9 are allowed</span>
			</div>
		</div>
		<div class="row pt-2 pb-2">
			<div class="col text-center">
				<span class="text-secondary">OR</span>
			</div>
		</div>
		<div class="form-floating">
			<input type="text" id="iccid" class="form-control" placeholder="Enter ICCID" name="iccid" formControlName="iccid" [(ngModel)]="getFilter('iccid').value">
			<label for="iccid">ICCID</label>
			<div *ngIf="filterForm.get('iccid')?.invalid && filterForm.get('iccid')?.touched" class="text-danger small">
				<span *ngIf="filterForm.get('iccid')!.errors">Expected a value of 19 to 20 digits long and only 0-9 are allowed</span>
			</div>
		</div>
		<div class="row pt-2 pb-2">
			<div class="col text-center">
				<span class="text-secondary">OR</span>
			</div>
		</div>
		<div class="form-floating">
			<input type="text" id="simSerial" class="form-control" placeholder="Enter Sim Serial" name="simSerial" formControlName="simSerial" [(ngModel)]="getFilter('simSerial').value">
			<label for="simSerial">Sim Serial</label>
			<div *ngIf="filterForm.get('simSerial')?.invalid && filterForm.get('simSerial')?.touched" class="text-danger small">
				<span *ngIf="filterForm.get('simSerial')!.errors">Expected a value of 8 to 20 digits long and only 0-9 are allowed</span>
			</div>
		</div>
		<p>This allows flexible and efficient lookup of subscriber or SIM information using industry-standard identifiers.</p>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-primary" (click)="modal.close('Close click')">Search</button>
	</div>
</ng-template>
